module.exports = __webpack_public_path__ + "static/media/welcome-splash.92d74e9a.png";